module.exports = {
	methods: {
		setMeta: function(meta){
			// title
			document.title = meta.title;

			// meta keywords, description, ogp
			var metaNodeList = document.getElementsByTagName('meta');

			Array.prototype.forEach.call(metaNodeList, function(node) {
				if (node['name'] === 'keywords'){
					node.setAttribute('content', meta.keywords);
				} else if (node['name'] === 'description'){
					node.setAttribute('content', meta.description);
				}

				if (node.hasAttribute('property')){
					switch (node.getAttribute('property')) {
					case 'og:title':
						node.setAttribute('content', meta.title);
						break;
					case 'og:description':
						node.setAttribute('content', meta.description);
						break;
					case 'og:url':
						node.setAttribute('content', meta.url);
						break;
					case 'og:image':
						if (meta.image){
							node.setAttribute('content', meta.image);
						}
						break;
					}
				}
			});
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/setMeta.js